import { Button, CircularProgress, DialogContent } from "@mui/material";
import { useState } from "react";
import pjson from "../../../../package.json";
import { TLDialogForm } from "../../../components/Dialog";
import { HiddenField, RHFTextField } from "../../../components/Forms";
import { useMsg } from "../../../components/Msg/Msg";
import { useStaticCallback } from "../../../hooks/useStaticCallback.hook";
import { isDevelopment, isProduction } from "../../../utils/environment";
import { useAuth } from "../../Authorization";
import { QueryRenderer } from "../../QM/QueryRenderer";
import { useDisconnectMutation } from "../api";
import { settingsMessages } from "../messages";

// on localhost we need to override origin, other envs can use origin "as is" and benefit from proxy
const getHrefForEnv = (path, developmentOrigin) => {
  const origin = isDevelopment()
    ? developmentOrigin || window.location.origin
    : window.location.origin;

  const url = new URL(path, origin);
  const href = url.href;

  // if (isDevelopment()) console.log("[getHref]", { path, origin, url, href });

  return href;
};

const getGCalHref = () => {
  return getHrefForEnv(`/login/google`, pjson?.proxy);
};

// QA:
// https://calendly.com/oauth/authorize?client_id=PJ2FbDI-YAyzEJya2H4RqHv_Sv0F-Hl0d-i93FkAuH8&response_type=code&redirect_uri=https://qa.topleaderplatform.io/login/calendly

// prod:
// https://calendly.com/oauth/authorize?client_id=vnzwTereNrHoVzQbrJMAhQM3KRfRxUPXHNtiQ-R0KJw&response_type=code&redirect_uri=https://qa.topleaderplatform.io/login/calendly

// new username param example from @jakub
// https://auth.calendly.com/oauth/authorize?client_id=N-KXDNA47C_aFv-ulHf4BFsrh7tOAzDSAcRtKuMDDXI&response_type=code&redirect_uri=http://localhost:8080/login/calendly?username=coach1

const getCalendlyHref = ({
  username,
  clientId = isProduction()
    ? "2y-RjGqvvMeKw6SluocvUde2dklW58cAvsuU6mchbY8"
    : "PJ2FbDI-YAyzEJya2H4RqHv_Sv0F-Hl0d-i93FkAuH8",
} = {}) => {
  const redirectUri =
    getHrefForEnv(
      "/login/calendly",
      "https://qa.topleaderplatform.io", // not working with localhost or proxy
    ) + `?username=${username}`;
  return `https://calendly.com/oauth/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}`;
};

export const INTEGRATION_TYPE = {
  GOOGLE: "GOOGLE",
  CALENDLY: "CALENDLY",
};

const INTEGRATION_STATUS = {
  OK: "OK",
  WARN: "WARN",
  ERROR: "ERROR",
};

const getTitle = ({ status, lastSync } = {}) =>
  [status, lastSync && `Last sync: ${lastSync}`].filter(Boolean).join(", ");

export const IntegrationStatusButton = ({ integrationType, query }) => {
  const msg = useMsg({ dict: settingsMessages });
  const { userQuery } = useAuth();
  const buttonProps = {
    [INTEGRATION_TYPE.GOOGLE]: {
      href: getGCalHref(),
      component: "a",
      variant: "outlined",
    },
    [INTEGRATION_TYPE.CALENDLY]: {
      href: getCalendlyHref({ username: userQuery.data?.username }),
      component: "a",
      variant: "outlined",
    },
  }[integrationType];
  const disconnectMutation = useDisconnectMutation({ integrationType });

  return (
    <QueryRenderer
      query={query}
      loading={() => <CircularProgress size={20} color="primary" />}
      success={({ data }) => {
        if (!data?.active)
          return (
            <Button {...buttonProps}>
              {msg("settings.integrations.connect")}
            </Button>
          );
        else if (data.status !== INTEGRATION_STATUS.OK)
          // return (
          //   <SplitButton
          //     variant={buttonProps.variant}
          //     buttonProps={{
          //       title: getTitle(data),
          //       children: msg("settings.integrations.reconnect"),
          //       ...buttonProps,
          //     }}
          //     options={[
          //       {
          //         label: msg("settings.integrations.disconnect"),
          //         onClick: () => {
          //           disconnectMutation.mutate();
          //         },
          //         disabled: disconnectMutation.isPending || query.isFetching,
          //       },
          //     ]}
          //   />
          // );
          return (
            <Button title={getTitle(data)} {...buttonProps}>
              {msg("settings.integrations.reconnect")}
            </Button>
          );
        else
          return (
            <Button
              title="Connected"
              variant="outlined"
              color="error"
              onClick={() => disconnectMutation.mutate()}
              disabled={disconnectMutation.isPending || query.isFetching}
            >
              {msg("settings.integrations.disconnect")}
            </Button>
          );
      }}
    />
  );
};
